import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { TextField, Button, Grid, Typography } from "@material-ui/core";
import ControlledSelect from "./controlledSelect";
import "date-fns";
import { useEffect, useState } from "react";

export default function AddKSADialog({
    open,
    handleClose,
    data,
    onChange,
    handleFormSubmit,
    countries,
    legalEntityMap,
    purchaseTypeMap,
    customerTypeMap,
    referenceTypeMap,
    ksaLegalEntityMap,
    handleDefaultChoice,
    handleClearFilters,
}) {
    const [currencyOptions, setCurrencyOptions] = useState([
        { label: "USD", value: "USD" },
    ]);

    const legalEntityOptions = [];
    const purchaseTypeOptions = [];
    const customerTypeOptions = [];
    const referenceTypeOptions = [];
    const ksaLegalEntityOptions = [];

    let currencyForLegalEntity = localStorage.getItem("currencyForLegalEntity");
    useEffect(() => {
        if (currencyForLegalEntity) {
            setCurrencyOptions([
                {
                    label: CurrencyForLegalEntity,
                    value: CurrencyForLegalEntity,
                },
            ]);
        } else {
            setCurrencyOption(data.legalEntity.value);
        }
    }, [currencyForLegalEntity]);

    for (let [key, val] of legalEntityMap) {
        legalEntityOptions.push({
            label: val,
            value: key,
        });
    }

    for (let [key, val] of purchaseTypeMap) {
        purchaseTypeOptions.push({
            label: val,
            value: key,
        });
    }

    for (let [key, val] of customerTypeMap) {
        customerTypeOptions.push({
            label: val,
            value: key,
        });
    }

    for (let [key, val] of referenceTypeMap) {
        referenceTypeOptions.push({
            label: val,
            value: key,
        });
    }

    for (let [key, val] of ksaLegalEntityMap) {
        ksaLegalEntityOptions.push({
            label: val,
            value: key,
        });
    }

    const handleLegalEntityChange = (event) => {
        localStorage.setItem("CurrencyForLegalEntity", event.target.value);
        localStorage.setItem("LegalEntityForDefault", data.legalEntity.value);
        setCurrencyOption(event.target.value);
        onChange(event);
    };

    const setCurrencyOption = async (countryISO2Code) => {
        if (countryISO2Code !== "EU") {
            if (countryISO2Code === "UA") {
                countryISO2Code = "AE";
            }
            const country = countries.get(countryISO2Code);
            const options = [];
            if (country?.currencyLists) {
                country.currencyLists.map((item) => {
                    options.push({
                        label: item.currencyCode,
                        value: item.currencyCode,
                    });
                });
                setCurrencyOptions(options);
                if (options.length === 1) {
                    data.currency.value = options[0].value;
                }
            }
        } else {
            let defaultOption;

            defaultOption = { label: "EUR", value: "EUR" };

            setCurrencyOptions([defaultOption]);
            data.currency.value = defaultOption.value;
        }
    };

    const handleClearAllFilters = () => {
        setCurrencyOptions([{ label: "", value: "" }]);
        handleClearFilters();
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <form onSubmit={handleFormSubmit}>
                    <DialogTitle id="alert-dialog-title">
                        Generate a New Invoice Number
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle1" component="p">
                            Enter the information below and submit to receive a
                            unique invoice number.
                        </Typography>
                        <div
                            style={{ marginBottom: "15px", display: "block" }}
                        ></div>
                        <Grid container spacing={5}>
                            <Grid item xs={12} sm={4}>
                                <ControlledSelect
                                    id="legalEntity"
                                    value={data.legalEntity.value}
                                    onChange={handleLegalEntityChange}
                                    label="Legal Entity"
                                    placeholder="Select legal entity"
                                    variant="filled"
                                    options={legalEntityOptions}
                                    hasError={data.legalEntity.hasError}
                                    required={true}
                                    includeAllFlag="false"
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <ControlledSelect
                                    id="currency"
                                    value={data.currency.value}
                                    label="Currency"
                                    placeholder="Select currency"
                                    variant="filled"
                                    options={currencyOptions}
                                    onChange={onChange}
                                    hasError={data.currency.hasError}
                                    required={true}
                                    includeAllFlag="false"
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField
                                    type="text"
                                    id="referenceNumber"
                                    placeholder="Enter Reference Number"
                                    label="Reference Number"
                                    variant="filled"
                                    onChange={onChange}
                                    value={data.referenceNumber.value}
                                    fullWidth
                                    required
                                />
                            </Grid>
                        </Grid>
                        <div
                            style={{ marginBottom: "15px", display: "block" }}
                        ></div>
                        <Grid container spacing={5}>
                            <Grid item xs={12} sm={4}>
                                <ControlledSelect
                                    id="referenceType"
                                    value={data.referenceType.value}
                                    label="Reference Type"
                                    placeholder="Reference Type"
                                    variant="filled"
                                    options={referenceTypeOptions}
                                    required={true}
                                    onChange={onChange}
                                    hasError={data.referenceType.hasError}
                                    includeAllFlag="false"
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <ControlledSelect
                                    id="purchaseType"
                                    value={data.purchaseType.value}
                                    label="Purchase Type"
                                    placeholder="Purchase Type"
                                    variant="filled"
                                    options={purchaseTypeOptions}
                                    onChange={onChange}
                                    required={true}
                                    hasError={data.purchaseType.hasError}
                                    includeAllFlag="false"
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <ControlledSelect
                                    id="customerType"
                                    value={data.customerType.value}
                                    label="Customer Type"
                                    placeholder="Customer Type"
                                    variant="filled"
                                    options={customerTypeOptions}
                                    onChange={onChange}
                                    required={true}
                                    hasError={data.customerType.hasError}
                                    includeAllFlag="false"
                                />
                            </Grid>

                            {data.legalEntity.value === "SA" &&
                                data.purchaseType.value === "I" && (
                                    <Grid item xs={12} sm={4}>
                                        <ControlledSelect
                                            id="ksaLegalEntity"
                                            value={data.ksaLegalEntity.value}
                                            label="KSA Legal Entity"
                                            placeholder="KSA Legal Entity"
                                            variant="filled"
                                            options={ksaLegalEntityOptions}
                                            onChange={onChange}
                                            required={true}
                                            hasError={
                                                data.ksaLegalEntity.hasError
                                            }
                                            includeAllFlag="false"
                                        />
                                    </Grid>
                                )}
                        </Grid>

                        <div
                            style={{ marginBottom: "15px", display: "block" }}
                        ></div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleDefaultChoice}
                            color="secondary"
                            variant="outlined"
                        >
                            Set as default
                        </Button>
                        <Button
                            onClick={handleClearAllFilters}
                            color="secondary"
                            variant="outlined"
                        >
                            Clear filters
                        </Button>
                        <Button
                            onClick={handleClose}
                            color="secondary"
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
